<template>
    <a
        v-if="url"
        :href="url"
        target="_blank"
        rel="noopener noreferrer"
        class="guideline-download"
    >
        <p class="guideline-download__text">
            <slot />
        </p>

        <strong class="guideline-download__name">
            <slot name="name" />

            <BaseIcon icon="file-pdf" />
        </strong>
    </a>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: null,
            required: true
        }
    }
};
</script>

<style lang="less">
.guideline-download {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    padding: var(--spacing-sm) var(--spacing-lg);

    color: var(--color-darkest);
    background: var(--color-lightest);
    box-shadow: var(--boxShadow-base);
    border-radius: var(--borderRadius-xs);
    text-decoration: none;

    transition: background-color var(--transition-fast);

    &:hover, &:focus {
        .guideline-download__name {
            color: var(--color-primary);
        }
    }

    &:active {
        background-color: var(--color-gray-200);
    }

    @media @q-md-min {
        padding: var(--spacing-lg);

        > * + * {
            display: inline-block;
            margin-top: var(--spacing-md);
        }
    }
}

.guideline-download__name {
    .typography-label-secondary;

    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: color var(--transition-fast);

    .dn-icon {
        flex: 0 0 auto;
        font-size: 1.5rem;
    }
}

.guideline-download__text {
    @media @q-md-max {
        display: none;
    }
}

</style>
